var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"pa-2 mt-0 pt-0",attrs:{"data-testid":_vm.testId,"dense":"","hide-details":"","color":"primary","indeterminate":_vm.indeterminate,"input-value":_vm.checked},on:{"change":_vm.onChange},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{staticClass:"font-size-md"},[_vm._v("Select all")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }